import { css } from 'styled-components';

export const fontFaces = css`
  @font-face {
    font-family: 'Londrina Solid';
    font-weight: 900;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Open sans';
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Opens sans';
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Opens sans';
    font-weight: 700;
    font-style: italic;
    font-display: swap;
  }
`;
